import { useContext } from "react";
import { Context } from "../../../context/Context";
import { useAccess } from "../../../access/hooks/useAccess";
import { getLocalized, getTemplateGroups } from "../utils/notificationHelpers";

export default function TemplateList({
  templates,
  category,
  selectedTemplateId,
  onSelect,
  t,
}) {
  const { lang = "ar" } = useContext(Context);
  const { can } = useAccess();

  if (category === "ticket") {
    return (
      <div className="lud-notif-template-list">
        {(templates.ticket || []).map((template) => (
          <button
            key={template.id}
            type="button"
            className={`lud-notif-template-item ${selectedTemplateId === template.id ? "is-selected" : ""}`}
            onClick={() => onSelect(template.id)}
          >
            <strong>{getLocalized(template, "nameAr", "nameEn", lang)}</strong>
            <span>
              {getLocalized(template, "bodyAr", "bodyEn", lang).slice(0, 60)}...
            </span>
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="lud-notif-template-list">
      {getTemplateGroups(
        templates,
        lang,
        can("notification.template.menuGroup")
          ? "menu"
          : can("notification.template.reportGroup")
            ? "report"
            : "manager",
      ).map((group) => (
        <div className="lud-notif-template-group" key={group.key}>
          <div className="lud-notif-template-group-label">{group.label}</div>
          {group.list.map((template) => (
            <button
              key={template.id}
              type="button"
              className={`lud-notif-template-item ${selectedTemplateId === template.id ? "is-selected" : ""}`}
              onClick={() => onSelect(template.id)}
            >
              <strong>
                {getLocalized(template, "nameAr", "nameEn", lang)}
              </strong>
              <span>
                {getLocalized(template, "bodyAr", "bodyEn", lang).slice(0, 60)}
                ...
              </span>
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}
